// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '동구바이오제약',
  targetSheetName: '요율표(26.06)',
  headerRowIndex: 11,
  headerRowCount: 1,
  dataStartRowIndex: 12,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '약가',
    commissionRate: '요율(%) (vat포함)',
    commissionNote: '비고',
  },
  requiredHeaders: [
    'No',
    '계열',
    '제품명',
    '성분명',
    '약가',
    '보험코드',
    '요율(%) (vat포함)',
    '자사생산',
    '비고',
  ],
});
